<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@font-face {
  font-family: hyllhj;
  src: url("/static/hyllhj.ttf");
}
@font-face {
  font-family: lianmengqiyilushuaizhengruiheiti;
  src: url("/static/LianMengQiYiLuShuaiZhengRuiHeiTi-2.ttf");
}
html,
body,
template,
.body,
#app,
#body,
#cesiumContainer {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  font-size: 14px;
}
#body {
  height: calc(100% - 50px);
}
#link .header,
#link .leftSidebarFilter,
#link .leftSidebar,
#link .breadcrumb {
  display: none;
}
#link .content-body {
  margin-top: 60px;
}
#link .content {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.en.leftSidebar,
.en.leftSidebarFilter {
  width: 200px;
}
.en.content {
  width: calc(100% - 215px);
  left: 215px;
}
.cesium-viewer-toolbar,
.cesium-viewer-bottom {
  display: none;
  /*z-index: 10000;*/
}
.viewer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.cesium-tools {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 20px 30px;
  background: #fff;
  width: auto;
  height: auto;
  box-sizing: border-box;
}
.cesium-animation-svgText {
  /*display: none;*/
}
.right_menu {
  width: 90px;
  box-sizing: border-box;
  list-style: none;
  position: fixed;
  top: 0;
  left: 0;
  padding: 10px 0px;
  text-align: center;
  background: #fff;
  font-size: 14px;
  box-shadow: 0 0 4px 0 #ccc;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1000;
}
.right_menu li:hover {
  background-color: #ccc;
}
.el-message-box {
  width: auto;
}
#layerInfo {
  position: fixed;
  top: -100px;
  left: -100px;
  padding: 5px 10px;
  background: #fff;
  border-radius: 6px;
  animation: cssAnimation 3s infinite;
  animation-iteration-count: 1;
  box-sizing: border-box;
}
@keyframes cssAnimation {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.theme {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
}
.theme1 {
  background-image: url(assets/theme1.jpg);
}
.theme2 {
  background-image: url(assets/theme2.png);
}
.theme3 {
  background-image: url(assets/theme3.png);
}
.theme4 {
  background-image: url(assets/theme4.png);
}
.theme5 {
  background-image: url(assets/index_bg.png);
}
.theme6 {
  background-image: url(assets/theme0.jpg);
}
.dark_04162E {
  background-color: rgba(4, 22, 46, 0.6) !important;
}
.bright_316081 {
  background-color: rgba(49, 96, 129, 0.6) !important;
}
.toolsBarFloorMenu .popper__arrow {
  top: -7px !important;
}
.toolsBarFloorMenu .el-dropdown-menu__item:not(.is-disabled):hover {
  color: #000;
  background-color: #fff;
}
.header {
  width: 100%;
  height: 50px;
  left: 0;
  top: 0;
  position: absolute;
  box-sizing: border-box;
  z-index: 4;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(50px);
}
.leftSidebarFilter,
.leftSidebar {
  width: 100px;
  height: calc(100% - 65px);
  top: 65px;
  left: 0;
  position: absolute;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  box-sizing: border-box;
  z-index: 4;
}
.contentFilter,
.content {
  width: calc(100% - 115px);
  height: calc(100% - 65px);
  top: 65px;
  left: 115px;
  position: absolute;
  box-sizing: border-box;
  /*padding: 20px;*/
  z-index: 3;
}
.filter {
  /*content: "";
  background: inherit;
  filter: blur(8px);*/
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(50px);
}
.header:after,
.content:after,
.leftSidebar:after {
  content: "";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  opacity: 0.15;
  background-color: #fff;
  z-index: -1;
}
.SideBar-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-scrollbar__thumb {
  opacity: 0;
}
ul.nav {
  width: 100%;
  display: block;
  box-sizing: border-box;
}
ul.nav > li > div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 15px 5px;
  /*margin: 10px 0;*/
  margin: 0;
  cursor: pointer;
  border-radius: 6px;
  position: relative;
}
ul.nav > li span {
  width: 100%;
  height: 20px;
  line-height: 20x;
  text-align: center;
  padding: 0 5px;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
  font-size: 16px;
}
ul.nav > li i {
  display: block;
  width: 30px;
  height: 30px;
  content: "";
  background-repeat: no-repeat;
  margin-bottom: 5px;
  transition: all 0.5s ease 0.2s;
  padding: 15px;
  background-position: center;
  border-radius: 8px;
}
ul.nav > li:hover i,
ul.nav > li .active i {
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(50px);
}

ul.nav > li .i-monitor {
  background-image: url(assets/monitor.png);
}
ul.nav > li:hover .i-monitor,
ul.nav > li .active .i-monitor {
  background-image: url(assets/monitor-ck.png);
}
ul.nav > li .i-homes {
  background-image: url(assets/homes.png);
}
ul.nav > li:hover .i-homes,
ul.nav > li .active .i-homes {
  background-image: url(assets/homes-ck.png);
}
ul.nav > li .i-bjsz {
  background-image: url(assets/bjsz.png);
}
ul.nav > li:hover .i-bjsz,
ul.nav > li .active .i-bjsz {
  background-image: url(assets/bjsz-ck.png);
}
ul.nav > li .i-lsgj {
  background-image: url(assets/lsgj.png);
}
ul.nav > li:hover .i-lsgj,
ul.nav > li .active .i-lsgj {
  background-image: url(assets/lsgj-ck.png);
}
ul.nav > li .i-qxgl {
  background-image: url(assets/qxgl.png);
}
ul.nav > li:hover .i-qxgl,
ul.nav > li .active .i-qxgl {
  background-image: url(assets/qxgl-ck.png);
}
ul.nav > li .i-qygl {
  background-image: url(assets/qygl.png);
}
ul.nav > li:hover .i-qygl,
ul.nav > li .active .i-qygl {
  background-image: url(assets/qygl-ck.png);
}
ul.nav > li .i-rygl {
  background-image: url(assets/rygl.png);
}
ul.nav > li:hover .i-rygl,
ul.nav > li .active .i-rygl {
  background-image: url(assets/rygl-ck.png);
}
ul.nav > li .i-sbgl {
  background-image: url(assets/sbgl.png);
}
ul.nav > li:hover .i-sbgl,
ul.nav > li .active .i-sbgl {
  background-image: url(assets/sbgl-ck.png);
}
ul.nav > li .i-tjgl {
  background-image: url(assets/tjgl.png);
}
ul.nav > li:hover .i-tjgl,
ul.nav > li .active .i-tjgl {
  background-image: url(assets/tjgl-ck.png);
}
ul.nav > li .i-xtsz {
  background-image: url(assets/xtsz.png);
}
ul.nav > li:hover .i-xtsz,
ul.nav > li .active .i-xtsz {
  background-image: url(assets/xtsz-ck.png);
}
ul.nav > li .i-patrolIcon {
  background-image: url(assets/patrolIcon.png);
}
ul.nav > li:hover .i-patrolIcon,
ul.nav > li .active .i-patrolIcon {
  background-image: url(assets/patrolIcon-ck.png);
}
ul.nav > li .i-region {
  background-image: url(assets/region1.png);
}
ul.nav > li :hover .i-region,
ul.nav > li .active .i-region {
  background-image: url(assets/region2.png);
}
.en ul.nav > li:hover ul.navChlid {
  opacity: 1;
  left: 180px;
}
ul.nav > li:hover ul.navChlid {
  opacity: 1;
  left: 80px;
}
ul.nav > li .i-taskManage {
  background-image: url(assets/tiskManage.png);
  background-size: 30px 30px;
}
ul.nav > li:hover .i-taskManage,
ul.nav > li .active .i-taskManage {
  background-image: url(assets/tiskManageH.png);
  background-size: 30px 30px;
}
ul.nav > li .i-custody {
  background-image: url(assets/custody.png);
  background-size: 30px 30px;
}
ul.nav > li:hover .i-custody,
ul.nav > li .active .i-custody {
  background-image: url(assets/custodyH.png);
  background-size: 30px 30px;
}
ul.nav > li .i-safe {
  background-image: url(assets/safe.png);
  background-size: 30px 30px;
}
ul.nav > li:hover .i-safe,
ul.nav > li .active .i-safe {
  background-image: url(assets/safeH.png);
  background-size: 30px 30px;
}
ul.nav > li .i-drill {
  background-image: url(assets/drill01.png);
}
ul.nav > li:hover .i-drill,
ul.nav > li .active .i-drill {
  background-image: url(assets/drill02.png);
  background-size: 30px 30px;
}
ul.nav > li .i-lamp {
  background-image: url(assets/lamp.png);
}
ul.nav > li:hover .i-lamp,
ul.nav > li .active .i-lamp {
  background-image: url(assets/lampH.png);
  background-size: 30px 30px;
}
ul.nav > li .i-jtgl {
  background-image: url(assets/jtgl.png);
}
ul.nav > li:hover .i-jtgl,
ul.nav > li .active .i-jtgl {
  background-image: url(assets/jtglH.png);
  background-size: 30px 30px;
}
ul.navChlid {
  /*min-height: 120px;*/
  display: block;
  box-sizing: border-box;
  padding: 10px 15px 10px 35px;
  left: -1000px;
  z-index: 5;
  /*transition: all .5s;*/
  opacity: 0;
  position: fixed;
}
ul.navChlid:after {
  content: "";
  top: 0;
  left: 20px;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(50px);
  position: absolute;
  z-index: -1;
  border-radius: 14px;
}
ul.navChlid > li {
  display: block;
  line-height: 30px;
  padding: 0 30px;
  border-radius: 12px;
  color: #141414;
  font-size: 14px;
  margin: 5px 0;
  /*font-weight: normal;*/
}
ul.navChlid > li:hover,
ul.navChlid > li.active {
  background-color: #ffceb0;
}
/*.themeSet {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}*/
.themeSet ul {
  display: none;
  position: absolute;
  top: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 60px;
  left: -60px;
  text-align: center;
  box-sizing: border-box;
  padding: 0px 15px;
}
.themeSet:hover ul {
  display: block;
}
.themeSet ul:after {
  content: "";
  opacity: 0.8;
  background-color: #fff;
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.themeSet ul li {
  display: block;
  margin: auto;
  width: 30px;
  height: 30px;
  margin: 15px 0;
  cursor: pointer;
}
.version {
  font-size: 14px;
  /*font-weight: bold;*/
  text-align: center;
  display: block;
  margin-top: 25px;
}
.el-table td,
.el-table th {
  padding: 7px 0;
}
th.header-cell-class {
  background-color: #d1d1d1 !important;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: #282828;
  line-height: 25px;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fdffe3 !important;
}
.el-table__body tr.current-row > td {
  background-color: #fcc7ab !important;
}
.el-table__body tr.cell-base {
  background-color: #fff;
}
.el-table__body tr.cell-even {
  background-color: #e8f0ff;
}
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: #b7b7b7 !important;
}
.btn-yellow {
  color: #202020;
  background-color: #ebdf71;
  border-color: #ebdf71;
}
.btn-yellow:hover {
  color: #202020;
  background-color: #fff490;
  border-color: #fff490;
}
.btn-yellow:focus {
  color: #202020;
  background-color: #fff490;
  border-color: #fff490;
}
.breadcrumb {
  line-height: 60px;
  color: #dcdcdc;
  padding: 0 20px;
  height: 60px;
}
.el-table .hovered-row {
  background: #fdffe3 !important;
}

.breadcrumb font {
  cursor: pointer;
}
.content-body {
  width: 100%;
  height: calc(100% - 50px);
  box-sizing: border-box;
  position: relative;
  padding: 0 20px;
}
.el-popover {
  height: 300px;
  overflow-y: auto;
}
.content-body .el-table__body-wrapper {
  overflow-y: auto;
  height: calc(100% - 73px);
}
.content-body .el-select,
.el-cascader {
  width: 100%;
}
.content-body .el-form-item {
  background-color: #eeeeee;
  box-shadow: 0 0 1px #000;
  margin-bottom: 1px !important;
  min-height: 29px;
  /*border-right: 1px solid #ccc;*/
}
.content-body .el-input__inner,
.el-textarea__inner {
  border-width: 0;
  border-radius: 8px;
}
.content-body .el-form-item__content {
  border-left: 1px solid #999;
  background-color: #fff;
}
.content-body .el-dialog__header {
  background-color: #e8e8e8;
  padding: 5px 20px;
}
.content-body .el-dialog__headerbtn {
  top: 10px;
  right: 10px;
}
.content-body .el-dialog__title {
  font-size: 14px;
  font-weight: bold;
  color: #272727;
}
.content-body .el-form-item__error {
  top: 7px;
  left: auto;
  right: 40px;
}
.content-body .el-radio {
  margin: 0 15px;
}
.content-border .el-input__inner {
  border: 1px solid #ccc;
}
.input33,
.input33 input {
  width: 40px;
  /*border-bottom: 1px solid red;*/
  box-shadow: 0px 1px 0px 0px red;
  height: 20px !important;
  line-height: 20px !important;
  padding: 0 0 !important;
  text-align: center;
  border-radius: 0 !important;
}
.startMap {
  position: fixed;
  bottom: 100px;
  left: calc(50% - 40px);
  /*left: 50%;*/
  z-index: 999;
  width: 160px;
  height: 40px;
  line-height: 40px;
  background-color: rgba(14, 48, 242, 0.4);
  backdrop-filter: blur(50px);
  box-shadow: 0px 0px 10px 0px #333;
  text-align: center;
  font-size: 18px;
  /*font-weight: bold;*/
  letter-spacing: 5px;
  border-radius: 8px;
  text-decoration: none;
  color: #fff;
}

.entityInfo {
  position: absolute;
  /*display: none;*/
  padding: 20px;
  filter: drop-shadow(6px 8px 15px rgb(0 0 0/30%));
  /*background-color: rgba(255,255,255,.4);*/
  /*backdrop-filter: blur(50px);*/
  box-sizing: border-box;
  right: -400px;
  top: 450px;
  color: #fff;
  overflow: hidden;
  transition: all 0.5s;
  z-index: 1001;
  background-image: url(assets/entityInfo.png);
  background-repeat: no-repeat;
  width: 329px;
  height: 203px;
  background-size: 100% 100%;
}
.entityInfo.show,
.carInfo.show,
.lampInfo.show {
  right: 20px;
}
.entityInfo .entityInfoT {
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}
.entityInfo .psImg {
  width: 87px;
  height: 112px;
  opacity: 1;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  position: absolute;
  right: 0px;
  top: 28px;
}
.entityInfo .psImg img {
  width: 100%;
  min-height: 100%;
}

.entityInfo .close {
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: -10px;
  right: -10px;
}
.carinfo .close {
  top: -2px;
  right: -2px;
}
.entityInfo .psInfo {
  /*float: right;*/
  font-size: 14px;
  text-align: left;
  padding-left: 5px;
  padding-top: 26px;
  box-sizing: border-box;
}
.entityInfo .psInfo > p {
  margin-bottom: 8px;
}

.entityInfo .psBtn {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;
}
.entityInfo .psBtn a {
  display: block;
  width: 40%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  font-size: 14px;
  text-decoration: none;
  /*color: #fff;
	background-color: rgba(255,255,255,.2);*/
  /*backdrop-filter: blur(50px);*/
  margin: 0 5%;
  color: #f5db45;
}
.entityInfo.lampinfo {
  background-image: url(assets/lampBgc.png);
  height: 320px;
  width: 340px;
  line-height: 30px;
}
.lampinfo .t {
  text-align: right;
}
.entityInfo.carinfo {
  background-image: url(assets/carBgc.png);
  height: 260px;
  width: 329px;
}
.carinfo .Info {
  padding: 8px;
}
.carinfo .Info > div {
  line-height: 26px;
}
.search-left {
  position: absolute;
  border-radius: 10px;
  left: 20px;
  width: 300px;
  border-radius: 10px;
  color: #fff;
  top: 20px;
  display: flex;
  display: flex;
  padding: 5px 10px;
  align-items: center;
  z-index: 999;
  background-color: rgba(4, 22, 46, 0.6);
  backdrop-filter: blur(50px);
}

.search-left .el-input__inner {
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 30px;
  height: 35px;
  width: 130px;
}
.search-left .el-input__inner::placeholder {
  font-size: 12px;
  color: #fff;
}
.toolsBox {
  position: absolute;
  left: 20px;
  width: 300px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 0 15px;
  color: #fff;
  box-shadow: 6px 8px 15px rgb(0 0 0/30%);
  background-color: rgba(4, 22, 46, 0.6);
  /* backdrop-filter: blur(50px); */
  transition: all 1s;
  height: 47%;
}
.toolsBox.close {
  left: -300px;
  box-shadow: none;
}
.en .box-title,
.en .regionStretchTitle {
  height: 260px;
  top: calc(50% - 150px);
}
.box-title {
  border: 1px solid #d9d9db;
  border-radius: 100px;
  width: 40px;
  height: 160px;
  position: absolute;
  right: -43px;
  top: calc(50% - 100px);
  writing-mode: vertical-lr;
  text-align: center;
  line-height: 40px;
  letter-spacing: 5px;
  display: none;
  background-color: rgba(4, 22, 46, 0.6);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  color: #fff;
}
.toolsBox.close .box-title {
  display: block;
}
.toolsBox .switchClose {
  transform: rotate(0deg);
  right: -54px;
  width: 12px;
  height: 50px;
  position: absolute;
  top: calc(50% - 46px);
  cursor: pointer;
}
.toolsBox .switchOpen {
  width: 12px;
  height: 50px;
  position: absolute;
  right: 0px;
  top: calc(50% - 25px);
  cursor: pointer;
  transform: rotate(180deg);
}
.toolsBox .searchInput {
  width: 100%;
  overflow: hidden;
  border-radius: 14px;
  margin-top: 30px;
  margin-bottom: 15px;
  border: 1px solid #fff;
}
.toolsBox .searchInput .el-input__inner {
  background-color: transparent;
  color: #fff;
  border: none;
}
.toolsBox .searchInput .el-input__suffix,
.toolsBar .el-date-editor .el-range__close-icon,
.toolsBar .el-date-editor .el-range__icon,
.toolsBar .el-date-editor .el-range-separator,
.toolsBar .el-date-editor .el-range-input {
  color: #fff;
  background-color: transparent;
}
.toolsBox .searchList {
  text-align: center;
  font-size: 14px;
  overflow: auto;
}
.toolsBox .searchList .listItem {
  margin: 5px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.toolsBar {
  background-color: rgba(4, 22, 46, 0.6);
  backdrop-filter: blur(50px);
  /*width: 80%;*/
  height: 54px;
  border-radius: 27px;
  position: absolute;
  top: 20px;
  left: 10%;
  box-sizing: border-box;
  padding: 11px 20px;
}
.toolsBar .el-input__inner,
.toolsBar .el-input__inner:hover {
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 15px;
}
.toolsBar .el-select .el-input.is-focus .el-input__inner {
  border-color: #fff;
}
.toolsBar .el-input__suffix {
  color: #fff;
}
.toolsBar button {
  background-color: transparent;
  border: 1px solid #fff;
  height: 30px;
  padding: 0 15px;
  letter-spacing: 2px;
  color: #fff;
  display: inline-block;
  cursor: pointer;
  border-radius: 15px;
}
.toolsBarFloor {
  color: #fff;
  padding: 0 5px;
  display: flex;
  width: 150px;
}
.toolsBarFloor .toolsBarFloor-left {
  width: 96px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.toolsBarFloor .toolsBarFloor-person {
  flex: 1;
  text-align: right;
}
.text-overflow2 {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.blank {
  display: flex;
  align-items: center;
  font-size: 0;
}
.blank label {
  display: inline-block;
  width: 160px;
  text-align: right;
  margin-right: 20px;
  font-size: 16px;
  line-height: 40px;
}
.blank input {
  width: calc(100% - 130px);
  height: 38px;
  line-height: 38px;
  padding: 0 15px;
  border-width: 1px;
  font-size: 16px;
}
.blank input:focus-visible {
  border-width: 1px;
}
.eyes {
  margin-left: 30px;
  margin-right: 10px;
  cursor: pointer;
}
.alarmIcon {
  width: 25px;
  height: 25px;
  margin-right: 20px;
  position: relative;
}
.badge {
  background-image: url(assets/alarm.png);
  background-size: 100% 100%;
  animation: alarm 1s infinite;
}
@keyframes alarm {
  0% {
    background-image: url(assets/alarms.png);
  }
  50% {
    background-image: url(assets/alarm.png);
  }
  100% {
    background-image: url(assets/alarms.png);
  }
}
.badges {
  background-image: url(assets/alarm1.png);
  background-size: 100% 100%;
  animation: alarms 1s infinite;
}
@keyframes alarms {
  0% {
    background-image: url(assets/alarm2.png);
  }
  50% {
    background-image: url(assets/alarm1.png);
  }
  100% {
    background-image: url(assets/alarm2.png);
  }
}
.alarm-color {
  width: 20px;
  height: 20px;
  font-size: 20px;
  animation: alarms 1s infinite;
}
@keyframes alarms {
  0% {
    color: #fff;
  }
  50% {
    color: red;
  }
  100% {
    color: #fff;
  }
}
.person-background {
  color: #fff;
  background-color: red;
  animation: personBgc 1s infinite;
}
@keyframes personBgc {
  0% {
    background: #003665;
  }
  50% {
    background: red;
  }
  100% {
    background: #003665;
  }
}
.textRight {
  text-align: right;
}
.box-1 {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px solid #ffffff;
  border-radius: 10px;
  margin: 15px auto 0 auto;
}

.console {
  position: fixed;
  top: 120px;
  left: calc(50% - 250px);
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  width: 500px;
  z-index: 100;
}
.console img {
  height: 25px;
  display: block;
  margin-right: 10px;
}
.console .console-item {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.switch-tools {
  width: 1200px;
  z-index: 100;
  position: fixed;
  bottom: 30px;
  left: calc(50% - 560px);
  height: 80px;
  background-image: url(assets/indexbtns.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  box-sizing: border-box;
  padding-top: 30px;
}
.switch-tools img {
  cursor: pointer;
}
.box-a-1 {
  width: 580px;
  height: 100px;
  margin-top: 20px;
}
.box-a-2 {
  width: 300px;
  height: 100px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.3);
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  /*backdrop-filter: blur(20px);*/
}
.box-a-3 {
  width: 248px;
  height: 100px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.3);
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  /*backdrop-filter: blur(20px);*/
}
.box-a-img {
  width: 70px;
  height: 70px;
}
.en .box-a-c1 {
  width: 160px;
}
.box-a-c1 {
  width: 120px;
  height: 70px;
  line-height: 35px;
  padding-left: 30px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.box-a-c1 strong {
  font-size: 30px;
  color: #2686ff;
}
.box-a-c2 {
  width: 50%;
  height: 70px;
  line-height: 35px;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
.box-a-c2 p {
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-a-c2 img {
  width: 15px;
  height: 15px;
}
.en .charts-btn {
  width: 120px;
}
.charts-btn {
  width: 80px;
  height: 30px;
  top: 28px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  display: block;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  z-index: 999;
}
.charts-btn.active {
  background-color: #1f74f1;
}
.systemUser {
  display: flex;
  padding: 0 20px 0 10px;
  align-items: center;
  cursor: pointer;
  position: relative;
  height: 50px;
}
.systemUser .name {
  font-size: 18px;
  margin-right: 5px;
}
.systemUser:hover > i {
  transform: rotate(180deg);
  /*transition: all .2s;*/
}
.systemUser:hover > ul.user-set {
  display: block;
  transition: all 0.5s;
}
.en ul.user-set {
  min-width: 202px;
}
ul.user-set {
  display: none;
  padding: 0;
  margin: 0;
  position: absolute;
  z-index: 5;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
  color: #333;
  font-size: 14px;
  padding: 10px 0px;
  top: 50px;
  line-height: 30px;
  min-width: 150px;
  right: 20px;
}
ul.user-set > li {
  cursor: pointer;
  padding: 0 25px;
  position: relative;
}
ul.user-set li:hover {
  background: #ffceb0;
}
ul.user-set li > span {
  margin-left: 5px;
}
.user-sider {
}
.user-sider ul {
  padding: 0;
  margin: 0;
  text-decoration: none;
}
.user-sider ul li {
  font-size: 16px;
  color: #3d3d3d;
  line-height: 56px;
  text-align: center;
  display: block;
  cursor: pointer;
}
.user-sider ul li:hover,
.user-sider ul li.active {
  background-color: #ffbc64;
}
.user-sider1 {
  padding: 50px 40px;
  font-size: 14px;
  color: #000000;
}
.user-sider1 p {
  margin: 30px 0px;
}
.user-sider1 .user-label {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.user-sider2 {
  padding: 75px 25px;
}
.flex-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.user-img {
  width: 20px;
  height: 20px;
}
.user-strong {
  width: 90px;
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  text-align: center;
}
.user-desc {
  font-size: 14px;
  color: #7e7e7e;
}
.input-label {
  display: block;
  width: 110px;
  text-align: right;
}
.user-input {
  width: 300px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.input-desc {
  padding-left: 110px;
  font-size: 14px;
  color: #7e7e7e;
}
.map-box {
  position: relative;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  content: "";
  /*display: flex;*/
  overflow: hidden;
}
.mapContent {
  width: 100%;
  position: relative;
  cursor: pointer;
  /*transition: width .5s;*/
}
.mapImg {
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  padding: 0;
  margin: 0;
  z-index: 1;
}
.mapRanging {
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  padding: 0;
  margin: 0;
  z-index: 10;
}
.mapContentEl {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  z-index: 5;
  position: relative;
}
.entity {
  position: absolute;
  z-index: 6;
  color: #fff;
  z-index: 3;
  /*margin-top: -30px;*/
  /*margin-left: -15px;*/
}
.entity .entity_info {
  font-size: 12px;
  position: relative;
}
.entity .entity_img {
  width: 20px;
  height: 20px;
  display: block;
}
.entity .entity_img_car {
  width: 16px;
  height: 24px;
  display: block;
}
.entity .entity_No {
  color: #fff;
  background-color: rgba(0, 54, 101, 1);
  display: block;
  position: absolute;
  height: 20px;
  line-height: 20px;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 4px;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  /* width: 60px; */
  transition: all 0.3s;
}
.entity .camera {
  background-color: #442e01;
}
.entity .entity_No.on {
  background-color: rgba(255, 0, 0, 1);
  color: #fff;
}
.entity .entity_tips {
  background-color: rgba(0, 54, 101, 1);
  display: block;
  position: absolute;
  height: 20px;
  line-height: 20px;
  top: -20px;
  left: -30px;
  padding: 0;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  width: 90px;
  z-index: 101;
}
.entity .entity_tips ul {
  display: none;
  padding: 0;
  margin: 0;
  background-color: rgba(199, 152, 0, 1);
  position: absolute;
  left: 0;
  top: 20px;
  width: 100%;
}
.entity .entity_tips ul li:hover {
  background-color: rgba(178, 126, 1, 1);
}
.entity .entity_tips:hover > ul {
  display: block;
}
.entityAnimation {
  transition: all 2s linear 0s;
}
.tips {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  z-index: 600;
}
.mapContent canvas {
  z-index: 10;
}
.play-tool {
  position: absolute;
  right: 10px;
  color: #fff;
  bottom: 10px;
  z-index: 101;
  display: flex;
  justify-items: flex-start;
  align-items: center;
}
.play-tool img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.play-tool .multiple {
  position: relative;
  width: 40px;
  height: 20px;
  line-height: 20px;
  text-align: center;
}
.play-tool .multiple:hover ul {
  display: block;
}
.play-tool .multiple ul {
  display: none;
  position: absolute;
  bottom: 20px;
  text-align: center;
  line-height: 24px;
  background-color: rgba(0, 0, 0, 0.8);
}
.play-tool .multiple ul li {
  cursor: pointer;
  padding: 0 10px;
}
.play-tool .multiple ul li.active,
.play-tool .multiple ul li:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.entityList {
  width: 396px;
  height: 302px;
  background-image: url(assets/entityList.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 130px;
  right: -400px;
  z-index: 100;
  content: "";
  overflow: hidden;
  padding: 10px 25px;
  box-sizing: border-box;
  transition: all 0.5s;
  z-index: 1001;
}
.entityList.show {
  right: 20px;
}
.entityList .close {
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 12px;
}
.entityList .entity-num {
  color: #f5db45;
  font-size: 18px;
  font-weight: bold;
  color: #f5db45;
  font-family: Adobe Heiti Std R, Adobe Heiti Std R-R;
  line-height: 40px;
  padding-left: 10px;
}
.entityList .table-head {
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-family: Adobe Heiti Std R, Adobe Heiti Std R-R;
  font-weight: bold;
  line-height: 30px;
  background-color: rgba(0, 102, 255, 0.6);
}
.entityList .table-tr {
  font-size: 14px;
  font-family: Adobe Heiti Std R, Adobe Heiti Std R-R;
  color: #ffffff;
  text-align: center;
  line-height: 26px;
  display: flex;
}
.entityList .table-tr .plural {
  background-color: rgba(0, 72, 179, 0.6);
}
.entityList .table-tr .oper a {
  font-size: 14px;
  font-family: Adobe Heiti Std R, Adobe Heiti Std R-R;
  color: #e0c843;
  text-decoration: none;
}
.el-tooltip__popper {
  max-width: 20%;
}
.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  background: #f5f5f5 !important;
  color: #303133 !important;
}
#timeline {
  position: fixed !important;
}

/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */

.regionStretch {
  position: absolute;
  left: 0px;
  top: calc(50% - 25px);
  width: 12px;
  height: 50px;
  cursor: pointer;
}
.regionStretchTitle {
  height: 160px;
  border: 1px solid #f2f2f2;
  border-radius: 100px;
  background-color: rgba(4, 22, 46, 0.6);
  backdrop-filter: blur(50px);
  writing-mode: vertical-lr;
  letter-spacing: 3px;
  width: 40px;
  text-align: center;
  line-height: 38px;
  color: #fff;
}
.regionBox {
  position: absolute;
  left: -41px;
  top: calc(50% - 100px);
  width: 40px;
  z-index: 999;
}
.regionImge {
  position: absolute;
  left: -12px;
  transform: rotate(180deg);
  top: calc(50% - 30px);
  cursor: pointer;
}
.regionBigBox {
  position: absolute;
  top: 0px;
  right: 0px;
  transition: all 1s;
  height: 100%;
}
.closereg {
  right: -451px !important;
}
.el-step__title.is-process {
  color: #c0c4cc;
}
.is-finish {
  color: #000 !important;
}
.link-box .link-input .el-input__inner {
  height: 30px;
  padding: 0 10px;
}
.link-box .link-input .el-input__inner::placeholder {
  font-size: 12px;
}
.flowChart .el-dialog__header {
  background-color: #dcdcdc;
  padding: 10px 20px;
}
.flowChart .el-dialog__title {
  font-size: 14px;
  color: #393939;
}
.flowChart .el-dialog__headerbtn {
  top: 14px;
}
.flowChart .el-dialog__body {
  padding: 0;
}
.department-rank .el-tree-node__label {
  font-weight: 400;
}
.use-vehicle .el-upload-list--text {
  display: none;
}
.analysis-table .cell {
  font-weight: 700;
  color: #606266;
}
.el-form-item__label {
  font-weight: 700;
}
.analysis-form .el-form-item__label {
  flex-shrink: 0;
}
.analysis-form .el-form-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.analysis-form .el-form-item__content {
  margin-left: 0 !important;
  flex: 1;
}
.taskTable .cell {
  white-space: pre-line;
}
.winClass {
  width: 300px;
}
.cesium-viewer-fullscreenContainer {
  display: none;
}
.DrawArea {
  position: absolute;
  z-index: 2999;
  top: 50%;
  left: 50%;
  margin-top: -300px;
  margin-left: -400px;
  width: 800px;
  height: 600px;
  background-color: #000;
}
.selectLayerList {
  position: fixed;
  z-index: 3999;
  top: 35%;
  right: 580px;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 20px 0;
  background-image: url(assets/selectLayerList.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.layerItem {
  background-image: url(assets/layerItem.png);
  background-repeat: no-repeat;
  width: 45px;
  height: 25px;
  background-size: 100% auto;
  line-height: 25px;
  text-align: center;
  margin: 5px 0;
  cursor: pointer;
  display: block;
}
.cursor_hand {
  cursor: pointer;
}
/* .el-popover {
  white-space: pre-line;
} */
.spot-div {
  position: absolute;
  z-index: 9999;
  padding: 3px;
  background-color: red;
  color: #fff;
}
.table-body .el-table th {
  background-color: #d1d1d1 !important;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: #282828;
  line-height: 25px;
  border-right: 1px solid #ebeef5;
}
.table-body .el-table td {
  border-right: 1px solid #ebeef5;
}
.navigation-bar::-webkit-scrollbar {
  background-color: #f0f0f0;
  border-radius: 10px;
  width: 3px;
}
.navigation-bar::-webkit-scrollbar-thumb {
  background-color: #009dff;
}
.no-navigation-bar::-webkit-scrollbar {
  width: 0px;
}

.table-body .son-table {
  border-left: 1px solid #b7b7b7;
}
.table-body .son-table .has-gutter th{
  background-color: #fff !important;
  border-top: 1px solid #ebeef5;
} 
.constituency-panel {
  width: 310px;
  /*height: 140px;*/
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 10;
  border-radius: 10px;
  padding-bottom: 30px;
}
.constituency-panel .el-form-item {
  background-color:transparent;
  box-shadow: none;
}
.constituency-panel .el-form-item .el-form-item__label {
  color: #fff;
}
.constituency-panel .el-form-item__content {
  border: none;
  background-color:transparent;
}
.el-cascader-node>.el-radio{
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  right: -10px;
}
.el-cascader-node>.el-radio>.el-radio__input {
  visibility: hidden;
}
.real-time .el-progress-bar__outer {
  background-color: #91949f;
}
.real-time-main::-webkit-scrollbar {
  width: 12px;
  height: 100%;
  background-color: #646878;
  margin-left: 24px;
  border-radius: 5px;
}
.real-time-main::-webkit-scrollbar-thumb {
  background-color: #b2b4bc;
  border-radius: 5px;
}
/*.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
    line-height: 29px !important;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue